module.exports = __webpack_public_path__ + "static/media/reports.cf3f58a8.svg";